import React, { useRef, useState } from 'react'
import './Contact.css'
import emailjs from '@emailjs/browser';
import sidePhoto from "../../image/sideContact.jpg"

const Contact = () => {
    const form = useRef();
    const [done, setDone] = useState(false)
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_x0ek7q9', 'template_9xsbwus', form.current, 'WgxoKZ9Q1jKREO_mT')
            .then((result) => {
                console.log(result.text);
                setDone(true);
                form.current.reset();
            }, (error) => {
                console.log(error.text);
            });
    };
    return (
        <div className='contact'>
            <div className="form">
                <h1>Hire Me.</h1>
                <p>Connect with me via phone: <a href="tel:9315318116" className='connDetails' target={"_blank"}> 9315318116</a>   <br /> Mail : <a href="mailto:sharmagulshan252@gmail.com" className='connDetails' target={"_blank"}>
                    sharmagulshan252@gmail.com
                </a> </p>
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name="name" id="name" placeholder='Your Name *' required />
                    <input type="email" name="email" id="email" placeholder='Your email *' required />
                    <input type="text" name="subject" id="subject" placeholder='Write a subject' required />
                    <textarea name='message' className='message' placeholder='Your Message' />
                    <input type="submit" id="sub" value="SUBMIT" />
                    <span>{done && "Thanks for contacting me"}</span>
                </form>
            </div>
            <div className="pic">
                <img src={sidePhoto} width="500px" alt="" />
            </div>
        </div>
    )
}

export default Contact